import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { DeviceInstalledApplicationsStatusEffects } from './device-installed-applications.effects';
import { deviceInstalledApplicationsReducer } from './device-installed-applications.reducer';

export const provideDeviceInstalledApplicationsStore = () => [
  provideState('device-installed-applications', deviceInstalledApplicationsReducer),
  provideEffects([DeviceInstalledApplicationsStatusEffects]),
];
